import axios from 'axios'
import langCodeInterceptor from './langCodeInterceptor.util'
import * as Sentry from "@sentry/react";

const baseClient = axios.create({
	timeout: 15000
})

baseClient.interceptors.response.use(
	(response) => response,
	(error) => {
		Sentry.addBreadcrumb({
			category: "error",
			message: error.config.url,
			level: "error",
		});
		Sentry.captureException(error);
		return Promise.reject(error);
	},
);

langCodeInterceptor(baseClient)

export default baseClient
